//Angular
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
//Services
import { EmailValidatorService } from 'src/app/core/services/validators/email-validator.service';
import { ValidatorsService } from 'src/app/core/services/validators/validators.service';
import * as shajs from 'sha.js';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../../core/http/auth/auth.service';

@Component({
	selector: 'app-step2',
	templateUrl: './step2.component.html',
	styleUrls: ['./step2.component.scss'],
})
export class Step2Component {
	alias: string = '';

	//Esto permite que el invalid tooltip no se muestre al inicio
	submitted = false;

	//FORM STEP 2
	miFormulario: FormGroup = this.fb.group(
		{
			firstName: [
				,
				[
					Validators.required,
					Validators.minLength(3),
					Validators.maxLength(10),
					Validators.pattern(this.vs.namePattern),
				],
			],
			lastName: [
				,
				[
					Validators.required,
					Validators.minLength(3),
					Validators.maxLength(10),
					Validators.pattern(this.vs.namePattern),
				],
			],
			email: [
				,
				[Validators.required, Validators.pattern(this.vs.emailPattern)],
			],
			main_tlf: [
				,
				[
					Validators.required,
					Validators.minLength(10),
					Validators.maxLength(10),
				],
			],
			username: [
				,
				[
					Validators.required,
					Validators.minLength(3),
					Validators.maxLength(10),
					Validators.pattern(this.vs.usernamePattern),
					this.vs.noSePuedeRepetir,
				],
			],
			password: [, [Validators.required, Validators.minLength(6)]],
			confirmPassword: [, [Validators.required]],
		},
		{
			validators: [this.vs.camposIguales('password', 'confirmPassword')],
		}
	);

	// ERRORS
	get firstNameErrorsMsg(): string {
		const errors = this.miFormulario.get('firstName')?.errors;

		if (errors?.required) {
			return 'message.required_name';
		}

		return 'message.musthave';
	}

	get lastNameErrorsMsg(): string {
		const errors = this.miFormulario.get('lastName')?.errors;

		if (errors?.required) {
			return 'message.required_lastname';
		}

		return 'message.musthave';
	}

	get emailErrorsMsg(): string {
		const errors = this.miFormulario.get('email')?.errors;

		if (errors?.required) {
			return 'message.required_mail';
		} else if (errors?.pattern) {
			return 'message.valid_mail';
		} else if (errors?.emailTomado) {
			return 'message.taken_mail';
		}

		return 'message.musthave';
	}

	get usernameErrorsMsg(): string {
		const errors = this.miFormulario.get('username')?.errors;

		if (errors?.required) {
			return 'message.required_username';
		} else if (errors?.pattern) {
			return 'message.valid_username';
		} else if (errors?.noRepetir) {
			return 'message.taken_username';
		}
		return 'message.musthave';
	}

	get passwordErrormsg(): string {
		const errors = this.miFormulario.get('password')?.errors;
		if (errors?.required) {
			return 'message.required_mail';
		}
		return 'message.musthave';
	}

	constructor(
		private router: Router,
		private fb: FormBuilder,
		private vs: ValidatorsService,
		private emailValidator: EmailValidatorService,
		private _authService: AuthService,
		private toastr: ToastrService
	) {}

	validacionCampo(campo: string) {
		return (
			this.miFormulario.controls[campo].errors &&
			this.miFormulario.controls[campo].touched
		);
	}

	async addUserName() {
		if (this.miFormulario.value.email) {
			this.alias = this.miFormulario.value.email.split('@')[0];
		}
	}

	async submitFormulario() {
		this.submitted = true;

		if (this.miFormulario.invalid) {
			this.miFormulario.markAllAsTouched();
			return;
		}

		let body: object = {
			language: localStorage.getItem('language'),
			email: this.miFormulario.value.email,
			password: shajs('sha512')
				.update(this.miFormulario.value.password)
				.digest('hex'),
			first_name: this.miFormulario.value.firstName,
			surname: this.miFormulario.value.lastName,
			id_unit: Number(localStorage.getItem('select_unit')),
			alia: this.miFormulario.value.username,
			main_tlf: this.miFormulario.value.main_tlf,
		};

		let rest: any = await this._authService.registerConsumerAccount(body);
		if (!rest.mensaje_return.ERROR) {
			this.toastr.success(
				'Exitoso',
				'Se ha agregado el usuario con exito',
				{
					timeOut: 3000,
				}
			);
			this.miFormulario.reset();
			this.router.navigateByUrl('/');
		} else {
			this.toastr.error('Error', '' + rest.mensaje_return.ERROR_MESSAGE, {
				timeOut: 3000,
			});
			/* ADD:
            Falta mostrar un error si el back devuelve como TRUE rest.mensaje_return.ERROR
            Normalmente el back manda un mensaje, seria cuestion de ver los mensajes y ver si mostrarlo o
            mostrarle al cliente un error agradable como ejem: "Falla al intentar el registro, intente mas tarde"
      */
			//this.miFormulario.reset();
		}
	}
}
